import React, { useState, Context, ReactElement, Component } from "react";
import { datacenter_url } from "../components/top-navbar/interface";

const EnvContext: Context<[datacenter_url | undefined, React.Dispatch<React.SetStateAction<datacenter_url | undefined>>]> = React.createContext<
  [datacenter_url | undefined, React.Dispatch<React.SetStateAction<datacenter_url | undefined>>]
>([undefined, (_value: any) => {}]);

const EnvProvider: (props: any) => React.ReactElement<any, string | (new (props: any) => React.Component<any, any, any>)> | null = (
  props: any
): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  const [env, set_env]: [datacenter_url | undefined, React.Dispatch<React.SetStateAction<datacenter_url | undefined>>] = useState<datacenter_url | undefined>();
  return <EnvContext.Provider value={[env, set_env]}>{props.children}</EnvContext.Provider>;
};

export { EnvContext, EnvProvider };
